module.exports = __webpack_public_path__ + "img/信息发布.ce5a8429.svg";